export default __webpack_public_path__ + "static/media/arrow-down.0c4ada3a.svg";